import React, { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

import { BodyCopy, H2 } from '../components/Typography'
import Container from '../components/Container'
import RenderSlider from '../components/RenderSlider'
import { Col } from 'react-styled-flexboxgrid'
import Switch from '../components/Switch'
import media from 'css-in-js-media'

import FloorplanContext from './FloorplanContext'
import FloorplanSlider from './FloorplanSlider'
import { TabsWrap, Tabs, Tab, TabContent } from './Tabs'
import { Variables } from '../styles/Variables'
import Pricelist from './Pricelist'
import { useIntl } from 'react-intl'

const FloorplansWrapper = styled.section`
    background-color: ${Variables.color.pazola};
`

const Renders = styled.div`
    padding-top: 76px;

    ${media('<desktop')} {
        padding-top: 54px;
    }

    ${Container} {
        ${media('<desktop')} {
            padding: 54px 0;
        }
    }

    ${H2} {
        padding: 0 20px;
        ${media('<desktop')} {
            font-size: 24px;
            line-height: 30px;
        }
    }

    ${TabContent} {
        ${media('<desktop')} {
            padding: 0 20px 53px 20px;
        }
    }

    ${BodyCopy} {
        color: ${Variables.color.white};
        padding-bottom: 60px;
        width: 1098px;
        margin: 0 auto;
        font-family: ${Variables.font.title};
        font-style: normal;
        font-weight: 300;
        font-size: 38px;
        line-height: 44px;

        ${media('<desktop')} {
            font-size: 24px;
            line-height: 30px;
        }

        ${media('<largeDesktop')} {
            width: 100%;
            padding: 0;
        }
    }
`
const RenderSliders = styled.div``

const RenderToggleWrap = styled(TabsWrap)`
    margin-top: 40px;
    ${media('<desktop')} {
        margin-left: 20px;
        margin-right: 20px;
        margin-bottom: 26px;
    }

    ${media('>=desktop')} {
        margin-top: 60px;
        margin-bottom: 60px;
    }
`

const RenderToggle = styled(Tabs)`
    border: none;
`

const RenderToggle_Item = styled(Tab)`
    width: 548px;
    background-color: transparent;
    font-weight: 300;
    color: ${Variables.color.white};
    text-transform: capitalize;
`

const FloorplansSection = styled.div`
    margin-top: 75px;
    font-family: ${Variables.font.body};

    ${media('<desktop')} {
        margin-top: 16px;
    }

    ${Col} {
        width: 100%;
    }

    ${Container} {
        ${media('<desktop')} {
            padding-left: 0;
            padding-right: 0;
        }
    }

    ${RenderToggleWrap} {
        ${media('<desktop')} {
            margin-top: 20px;
            margin-bottom: 40px;
        }
    }
`

const FloorplanSliderWrap = styled.div`
    position: relative;
`

const FloorplanLinks = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 53px 0;

    font-family: ${Variables.font.body};
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: ${Variables.color.white};

    ${media('<desktop')} {
        padding: 20px;
        flex-direction: column;
        font-size: 12px;
    }
`

const ViewToggle = styled.div`
    transition: 0.1s opacity linear;
    position: relative;
    top: 1px;

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.2;
            pointer-events: none;
        `}
`

const DownloadButton = styled.a`
    font-family: ${Variables.font.body};
    font-size: 16px;
    line-height: 100%;
    text-align: center;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: ${Variables.color.white};
    display: flex;
    align-items: center;
    transition: 0.1s opacity linear;
    border: 1px solid ${Variables.color.white};
    position: relative;
    width: 221px;
    height: 44px;
    justify-content: center;

    ${media('<desktop')} {
        height: 40px;
        width: 177px;
        margin-top: 20px;
        font-size: 12px;
    }

    &:before {
        content: ' ';
        position: absolute;
        top: 3px;
        left: 3px;
        right: 3px;
        bottom: 3px;
        border: 1px solid ${Variables.color.white};
    }

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.2;
        `}
`

const PricelistWrapper = styled.div`
    padding-bottom: 60px;

    ${media('<desktop')} {
        padding-bottom: 50px;
    }
`

const PricelistItem = styled.div`
    display: none;
    ${({ active }) =>
        active &&
        css`
            display: block;
        `}
`

const StyledH2 = styled(H2)`
    color: ${Variables.color.white};
    font-size: 38px;
    line-height: 44px;
    text-align: center;
`

const PriceTitle = styled(H2)`
    color: ${Variables.color.white};
    font-family: ${Variables.font.title};
    font-style: normal;
    font-weight: 300;
    font-size: 38px;
    line-height: 44px;
    text-align: center;
    padding-bottom: 37px;
    ${media('<desktop')} {
        padding-bottom: 29px;
        font-size: 24px;
        line-height: 30px;
    }
`

export const Floorplans: React.FC<{
    data?: object
}> = ({ data }) => {
    const intl = useIntl()
    const { floorplans, id, title } = data
    const [getView, setView] = useState(false)
    const [getType, setType] = useState(floorplans && floorplans[0].title)

    const getRenderImages = () => {
        let data = []
        floorplans.map((floorplan) =>
            floorplan.renders.map((renderImage, i) => {
                data = [...data, { ...renderImage, type: floorplan.title }]
            })
        )
        return data
    }

    return (
        <>
            <FloorplanContext.Provider
                value={{
                    getView,
                    setType,
                }}
            >
                <FloorplansWrapper>
                    <Renders>
                        <StyledH2>{title}</StyledH2>
                        {floorplans.length > 1 && (
                            <RenderToggleWrap>
                                <RenderToggle>
                                    {floorplans.map((floorplan, index) => (
                                        <RenderToggle_Item
                                            key={index}
                                            active={getType == floorplan.title}
                                            onClick={() => setType(floorplan.title)}
                                        >
                                            {floorplan.title}
                                        </RenderToggle_Item>
                                    ))}
                                </RenderToggle>
                            </RenderToggleWrap>
                        )}
                        {floorplans.map((floorplan, index) => (
                            <TabContent
                                key={index}
                                active={getType == floorplan.title}
                                onClick={() => setType(floorplan.title)}
                            >
                                <BodyCopy
                                    dangerouslySetInnerHTML={{
                                        __html: floorplan.copy.childMarkdownRemark.html,
                                    }}
                                />
                            </TabContent>
                        ))}
                        <RenderSliders>
                            <RenderSlider images={getRenderImages()} id={id} />
                        </RenderSliders>
                    </Renders>

                    <FloorplansSection>
                        {floorplans.length > 1 && (
                            <RenderToggleWrap>
                                <RenderToggle>
                                    {floorplans.map((floorplan, index) => (
                                        <RenderToggle_Item
                                            key={index}
                                            active={getType == floorplan.title}
                                            onClick={() => setType(floorplan.title)}
                                        >
                                            {floorplan.title}
                                        </RenderToggle_Item>
                                    ))}
                                </RenderToggle>
                            </RenderToggleWrap>
                        )}
                    </FloorplansSection>
                    <PricelistWrapper>
                        <PriceTitle>{getType}</PriceTitle>
                        {floorplans.map((floorplan, index) => (
                            <PricelistItem key={index} active={getType == floorplan.title}>
                                <Pricelist data={floorplan.pricelist} />
                            </PricelistItem>
                        ))}
                    </PricelistWrapper>
                </FloorplansWrapper>
            </FloorplanContext.Provider>
        </>
    )
}
export default Floorplans
